import { FC } from 'react';
import { $Formutil, connect, EasyField, useForm } from 'react-bootstrap-formutil';
import Button from 'components/base/Button';
import Tag from 'components/base/Tag';
import { FormCheckNumberType } from 'types/common';
import classlist from 'utils/classlist';
import { printf } from 'utils/i18n';
import styles from './style.scss';

interface QuestionnaireEntryProps {
    $formutil: $Formutil<{
        is_professional: FormCheckNumberType;
    }>;
    disabled?: boolean;
    onClick: () => void;
    titleClassName?: string;
}

/**
 * 评估是否为专业用户问卷的入口，点击“修改”进入问卷详情页面，最终由回答答案决定是否为专业用户
 */
const QuestionnaireEntry: FC<QuestionnaireEntryProps> = ({ onClick, disabled, titleClassName }) => {
    const {
        $params: { is_professional }
    } = useForm();

    return (
        <>
            <h3 className={classlist('open-title', titleClassName)}>
                {__('Non-Professional Qualification Questionnaire')}
            </h3>
            <div className={styles.content}>
                <p className="mb-0">
                    {printf(
                        __('Base on the questionnaire, I confirm that I am a %s trader.'),
                        is_professional ? __('professional') : __('non-professional')
                    )}
                    {is_professional ? (
                        <Tag text={__('professional')} variant="success" />
                    ) : (
                        <Tag text={__('non-professional')} variant="info" />
                    )}
                </p>
                <Button className={styles.btn} onClick={onClick} type="link">
                    {disabled ? __('View') : __('Modify')}
                </Button>
            </div>
            <EasyField name="is_professional" defaultValue={0} type="hidden" />
            {/* 给后端标识问卷版本使用 前端不改变值 直接传v2 */}
            <EasyField type="hidden" name="questionnaire_version" key="questionnaire_version" defaultValue="v2" />
            <EasyField type="hidden" name="questionnaire_answer" key="questionnaire_answer" defaultValue="1" />
        </>
    );
};

export default connect(QuestionnaireEntry);
